import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ErrorFormatter } from './utils/error-formatter.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {

  constructor(
    private toaster: ToastrService,
    private errorFormatter: ErrorFormatter,
    ) { }

  /**
   * This handles errors on requests.
   * Should there be an error, it displays a message to the user and throws an error
   *
   * @param error Request error
   * @param messagePrefix Prefix of the message in order to distinguish the origin of the error
   */
  public formatErrors(error: any, messagePrefix: string): any {
    if (error.status >= 500 || error.status === 0) {
      return this.throwErrorAndMessage(error, `${messagePrefix} Server error`);
    }

    if (error.status >= 400 && error.status < 500 && error.status !== 401) {
      if (error.status === 404) {
        return throwError(error);
      } else {
        return this.throwErrorAndMessage(error, `${messagePrefix} Client error`);
      }
    }

    if (error.status === 401) {
      return this.throwErrorAndMessage(error, `${messagePrefix} Permission error`);
    }

    return of(error);
  }

  /**
   * This displays an error to the user and throws it
   * Error is not displayed if the user is not registered yet: the error will be caught afterwards
   *
   * @param error Request error
   * @param defaultTitle Title of the error to display
   */
  public throwErrorAndMessage(error: HttpErrorResponse, defaultTitle): any {
    if (!this.internalSignUpNeeded(error)) {
      const message = this.errorFormatter.formatMessage(error);
      defaultTitle = this.errorFormatter.formatTitle(error, defaultTitle);

      this.toaster.error(message, defaultTitle);
    }

    return throwError(error);
  }

  /**
   * Deducts more precisely by reading error message if the issue is due
   * to an unknown member needing to be registered fully in the system
   *
   * @param err
   *
   * @return
   */
  public internalSignUpNeeded(err: any): any {
    const message = err.error.error || err.error.message;
    return err.status === 401 &&
      (message.includes('Unable to check the token') || message.includes('Internal member registration needed'));
  }
}
